<script setup>
import NavigationBlock from "./MenuNavigationItem.vue";
defineProps({
  items: {
    type: Array,
    required: true,
  }
})
</script>

<template>
  <nav>
    <ul class="mobile-only">
      <li v-for="root_item in items"
          :class="root_item.class"
      >
        <i v-if="root_item.children?.length" class="mob-show-hide"></i>
        <a :href="root_item.link" :class="root_item.sub_class"
           :style="(root_item.color?'color:'+root_item.color+'!important;':'')">
          <div class="imgWraper" v-if="root_item.img" v-html="root_item.img"></div>
          {{ root_item.text }}
          <span v-if="root_item.children?.length"></span>
        </a>
        <NavigationBlock :items="root_item.children" />
      </li>
    </ul>
  </nav>
</template>

<style scoped lang="scss">

</style>